import styled, { css } from 'styled-components';
import {
  flexBoxCenter,
  justifyContentFlexEnd,
  justifyContentSpaceAround,
  layerA,
  layerA180Deg,
  layerB,
  layerCLighter,
} from 'shared/styles/commonStyles';
import { useState, useEffect, useCallback } from 'react';
import SelectBox from './SelectBox';
import { useDebounce, useSsrElementsBank } from 'shared/hooks';
import { getAdminHeatersService } from 'shared/services';
import HeatLoadSpecRow from './HeatLoadSpecRow';
import { makeBlankSpec } from 'features/settings/helpers/setting';

const SSRElements = ({
  SSRList,
  groupedSwitches,
  groupedIdx,
  switches,
  setSwitches,
}) => {
  const buttonTitles = ['add', 'clear'];


  const listOfTc = Array.from({ length: 11 }, (_, i) => {
    if (i < 9) {
      return 'tc-0' + (Number(i) + 1);
    } else {
      return 'tc-' + (Number(i) + 1);
    }
  });


  const selectedTcArr = Array.from({ length: SSRList.length }, (_, i) => '---');


  const openSelectBoxes = Array.from(
    { length: SSRList.length },
    (_, i) => false
  );


  const [selectedTc, setSelectedTc] = useState(selectedTcArr);
  const [openSelectSSRBox, setOpenSelectSSRBox] = useState(openSelectBoxes);
  const [listOfGroupedSwitches, setListOfGroupedSwitches] = useState([]);
  const [inputPartNumber] = useState('');


  const { elementsOptions: elementsOptionsStore } = useSsrElementsBank();
  const [elementsOptions, setElementsOptions] = useState(elementsOptionsStore);

  const inputPartNumberDebounced = useDebounce(inputPartNumber, 500);
  useEffect(() => {
    if (inputPartNumberDebounced) {
      getAdminHeatersService(inputPartNumberDebounced)
        .then((res) => {
          setElementsOptions(
            res.map((el) => {
              return {
                elementName: el.elementName,
                partNumber: el.partNumber,
                current: Number(el.current),
                wattage: Number(el.wattage),
                voltage: Number(el.voltage),
                lengths: Number(el.lengths),
              };
            })
          );
        })
        .catch((err) => {
          console.log('fail get admin heater:', err.message);
        });
    }
  }, [inputPartNumberDebounced]);

  useEffect(() => {

    const copySelectedTc = [...selectedTcArr];
    groupedSwitches.forEach((switchEl) => {
      switchEl.selectedSSR.forEach((ssr) => {
        const objKey = Object.keys(ssr)[0];
        SSRList.forEach((el, ssrIdx) => {
          if (el === objKey) {
            copySelectedTc[ssrIdx] = ssr[objKey].thermoCouple;
          }
        });
      });
    });

    setSelectedTc(copySelectedTc);


    let SwitchesArr = [];
    groupedSwitches.forEach((switchEl) => {
      SwitchesArr.push(switchEl.switchName);
    });
    setListOfGroupedSwitches(SwitchesArr);
  }, []);



  const handleOpenSelectBoxes = useCallback(
    (isSelectSwitch, SSRIdx, switchIdx, SSR) => {
      if (isSelectSwitch) {

        const copySwitches = [...switches];
        copySwitches[groupedIdx][SSRIdx].selectedSSR[switchIdx][
          SSR
        ].isSelectSwitchListOpen =
          !copySwitches[groupedIdx][SSRIdx].selectedSSR[switchIdx][SSR]
            .isSelectSwitchListOpen;
        setSwitches(copySwitches);
      } else {

        const copyOpenSelectSSRBox = [...openSelectSSRBox];
        copyOpenSelectSSRBox[SSRIdx] = !copyOpenSelectSSRBox[SSRIdx];
        setOpenSelectSSRBox(copyOpenSelectSSRBox);
      }
    },
    [openSelectSSRBox, switches]
  );



  const handleSelectTcBoxes = (selected, groupedIdx, SSR) => {
    const copySwitches = [...switches];
    copySwitches[groupedIdx].forEach(({ selectedSSR }, selectedIdx) => {
      selectedSSR.forEach((ssr, idx) => {
        const objKey = Object.keys(ssr)[0];

        if (objKey === SSR) {
          copySwitches[groupedIdx][selectedIdx].selectedSSR[idx][
            SSR
          ].thermoCouple = selected;
        }
      });
    });
    setSwitches(copySwitches);

    const tcIdx = +SSR.match(/\d+/g)[0] - 1;
    const copySelectedTc = [...selectedTc];
    copySelectedTc[tcIdx] = selected;
    setSelectedTc(copySelectedTc);
  };



  const handleSwitchSelectBoxes = (
    switchesIdx,
    selected,
    SSR

  ) => {
    const copySwitches = [...switches];
    const toBeRemoveSwitchesIdx = [];
    const selectedSSR = copySwitches[groupedIdx][switchesIdx].selectedSSR;

    copySwitches[groupedIdx].forEach((switchEl) => {
      if (switchEl.switchName === selected) {

        selectedSSR.forEach((el, idx) => {
          if (Object.keys(el)[0] === SSR) {
            el[SSR].isNewlyAdded = false;
            switchEl.selectedSSR.push(el);
            toBeRemoveSwitchesIdx.push(idx);
          }
        });
      }
    });


    toBeRemoveSwitchesIdx.slice().reverse().forEach((el) => {
      selectedSSR.splice(el, 1);
    });


    copySwitches[groupedIdx].forEach((switchEl, idx) => {
      if (idx !== switchesIdx) {
        switchEl.selectedSSR.forEach((el) => {
          if (Object.keys(el)[0] === SSR) {
            el[SSR].isNewlyAdded = false;
          }
        });
      }
    });

    setSwitches(copySwitches);
  };


  const handleAddClearButtons = (buttonIdx, SSR) => {
    const copySwitches = [...switches];

    switch (buttonIdx) {
      case 0:

        let existingSSRSwitch = null;
        copySwitches[groupedIdx].forEach((switchEl, idx) => {
          const hasSSR = switchEl.selectedSSR.some(el => Object.keys(el)[0] === SSR);
          if (hasSSR) {
            existingSSRSwitch = switchEl;
          }
        });

        if (existingSSRSwitch) {

          const ssrEntry = existingSSRSwitch.selectedSSR.find(
            (el) => Object.keys(el)[0] === SSR
          );

          if (ssrEntry[SSR].specs.length >= 3) {
            return;
          }

          ssrEntry[SSR].specs.push(makeBlankSpec());
        } else {


          const firstSwitchIdx = 0;


          const existingSSREntry = copySwitches[groupedIdx][firstSwitchIdx].selectedSSR.find(
            el => Object.keys(el)[0] === SSR
          );

          if (!existingSSREntry) {

            copySwitches[groupedIdx][firstSwitchIdx].selectedSSR.push({
              [SSR]: {
                thermoCouple: '---',
                isSelectSwitchListOpen: false,
                isNewlyAdded: false,
                currentSpecs: [],
                specs: [{
                  elementName: '',
                  partNumber: '',
                  currentCurrent: '',
                  current: '',
                  wattage: '',
                  voltage: '',
                  lengths: '',
                }],
              },
            });
          } else {

            if (existingSSREntry[SSR].specs.length >= 3) {
              return;
            }
            existingSSREntry[SSR].specs.push(makeBlankSpec());
          }
        }
        break;

      case 1:
        let switchIdx1 = '';


        copySwitches[groupedIdx].forEach((switchEl, idx) => {
          switchEl.selectedSSR.forEach((el) => {
            if (Object.keys(el)[0] === SSR) {
              switchIdx1 = idx;
            }
          });
        });

        if (switchIdx1 !== '') {
          const ssrEntry = copySwitches[groupedIdx][switchIdx1].selectedSSR.find(
            (el) => Object.keys(el)[0] === SSR
          );



          if (ssrEntry[SSR].specs.length > 1) {
            ssrEntry[SSR].specs.pop();
          } else {

            ssrEntry[SSR].specs = [];
          }
        }

        break;

      default:
        break;
    }

    setSwitches(copySwitches);
  };








  const handleSelectedPartNumber = (
    selectedItem,
    selectedSSRIdx,
    SSR,
    specsIdx,
    switchIdx
  ) => {
    const copySwitches = [...switches];

    copySwitches[groupedIdx][switchIdx].selectedSSR[selectedSSRIdx][
      SSR
    ].specs.splice(specsIdx, 1, selectedItem);

    setSwitches(copySwitches);
  };

  return (
    <>
      {SSRList?.map((SSR, SSRIdx) => {
        return (
          <Wrapper key={SSRIdx}>

            <SwitchTitlesWrapper>
              <SSRAndTCWrapper>
                <SSRWrapper>
                  <Ssr>{SSR}</Ssr>
                </SSRWrapper>

                <SelectBox
                  isTc={true}
                  displaySelectBox={openSelectSSRBox[SSRIdx]}
                  switchIdx={SSRIdx}
                  SSR={SSR}
                  handleOpenSelectBoxes={() =>
                    handleOpenSelectBoxes(false, SSRIdx)
                  }
                  handleSelectBoxes={handleSelectTcBoxes}
                  selectBoxFor={'tc'}
                  selected={selectedTc[SSRIdx]}
                  content={listOfTc}
                  isCreateEditOrSave={false}
                  groupedIdx={groupedIdx}
                />
              </SSRAndTCWrapper>
              <SubTitle isPartNum={true}>part number</SubTitle>
              <SubTitle isCurrent={true}>current (a)</SubTitle>
              <SubTitle isWattage={true}>wattage (w)</SubTitle>
              <SubTitle isVoltage={true}>voltage (v)</SubTitle>
              <SubTitle isLength={true}>length (ft)</SubTitle>
              <SubTitle isDescription={true}>description</SubTitle>
            </SwitchTitlesWrapper>


            <ElementsWrapper>
              {groupedSwitches?.map((element, elementIdx) => {
                return (
                  <div key={elementIdx}>
                    {element.selectedSSR.map((ssr, selectedSSRIdx) => {
                      const selectedSSR2 = Object.entries(ssr);
                      const key = selectedSSR2[0][0];
                      const value = selectedSSR2[0][1];
                      console.log()
                      return (
                        <div key={selectedSSRIdx}>
                          {key === SSR &&
                            value.specs.map((el, elIdx) => {
                              const isFirstElement = elIdx === 0;
                              return (
                                <EachSwitchSpecsWrapper key={elIdx}>
                                  <SelectSwitchWrapper>
                                    <SelectBox
                                      displaySelectBox={
                                        isFirstElement &&
                                        groupedSwitches[elementIdx].selectedSSR[
                                          selectedSSRIdx
                                        ][SSR].isSelectSwitchListOpen
                                      }
                                      switchIdx={elementIdx}
                                      SSR={SSR}
                                      handleOpenSelectBoxes={() =>
                                        isFirstElement &&
                                        handleOpenSelectBoxes(
                                          true,
                                          elementIdx,
                                          selectedSSRIdx,
                                          SSR
                                        )
                                      }
                                      handleSelectBoxes={handleSwitchSelectBoxes}
                                      selectedSSRIdx={selectedSSRIdx}
                                      selectBoxFor={'switch'}
                                      selected={
                                        value?.isNewlyAdded
                                          ? 'select switch'
                                          : element.switchName
                                      }
                                      content={listOfGroupedSwitches}
                                      isCreateEditOrSave={false}
                                      groupedIdx={groupedIdx}
                                      disabled={!isFirstElement}
                                    />
                                  </SelectSwitchWrapper>

                                  <HeatLoadSpecRow
                                    options={elementsOptions}
                                    handleSelectedPartNumber={
                                      handleSelectedPartNumber
                                    }
                                    selectedSSRIdx={selectedSSRIdx}
                                    SSR={SSR}
                                    elementIdx={elementIdx}
                                    elIdx={elIdx}
                                    el={el}
                                  />
                                </EachSwitchSpecsWrapper>
                              );
                            })}
                        </div>
                      );
                    })}
                  </div>
                );
              })}









              <ButtonsWrapper>
                {buttonTitles?.map((title, buttonIdx) => {
                  return (
                    <ButtonWrapper key={buttonIdx} isAddClear={true}>
                      <Button
                        isAddClear={true}
                        onClick={() => handleAddClearButtons(buttonIdx, SSR)}
                      >
                        <ButtonIndent isAddClear={true}>
                          <ButtonTop isAddClear={true}>
                            <Title>{title}</Title>
                          </ButtonTop>
                        </ButtonIndent>
                      </Button>
                    </ButtonWrapper>
                  );
                })}
              </ButtonsWrapper>
            </ElementsWrapper>
          </Wrapper>
        );
      })}
    </>
  );
};

export default SSRElements;
















































































































const Wrapper = styled.div`
  margin-top: 6px;
  &:first-child {
    margin-top: 4px;
  }
`;

const SwitchTitlesWrapper = styled.div`
  height: 24px;
  width: 100%;
  ${flexBoxCenter}
  gap:22.5px;
  position: relative;
`;

const SubTitle = styled.div`
  ${({ isPartNum, isCurrent, isWattage, isVoltage, isLength, isDescription }) =>
    isPartNum
      ? css`
          position: absolute;
          top: 5px;
          left: 149px;
        `
      : isCurrent
      ? css`
          position: absolute;
          top: 5px;
          left: 255px;
        `
      : isWattage
      ? css`
          position: absolute;
          top: 5px;
          left: 332px;
        `
      : isVoltage
      ? css`
          position: absolute;
          top: 5px;
          left: 408px;
        `
      : isLength
      ? css`
          position: absolute;
          top: 5px;
          left: 484px;
        `
      : isDescription &&
        css`
          position: absolute;
          top: 5px;
          left: 638px;
        `}

  height: 10px;
  width: auto;
  font-size: 8px;
  letter-spacing: 0.8px;
  color: #ffffff;
`;

const SSRAndTCWrapper = styled.div`
  width: 118px;
  height: 20px;

  ${layerCLighter}
  border-radius: 12px;
  ${flexBoxCenter}

  position: absolute;
  top: 0;
  left: 0px;
`;

const SSRWrapper = styled.div`
  width: 58px;
  ${flexBoxCenter}
`;

const Ssr = styled.span`
  font-size: 10px;
  color: #fcff01;
`;




const ElementsWrapper = styled.div`
  width: 808px;
  min-height: 63px;

  ${layerA180Deg}
  border-radius: 12px 12px 17px 12px;
`;

const EachSwitchSpecsWrapper = styled.div`
  width: 100%;
  height: 20px;
  margin-top: 4px;

  ${justifyContentSpaceAround}
  position:relative;
`;

const SelectSwitchWrapper = styled.div`
  width: 116px;
  height: 20px;

  ${layerA}

  border-radius: 12px;

  ${flexBoxCenter}
`;














const ButtonsWrapper = styled.div`
  width: 99.7%;
  margin-top: 8px;
  margin-bottom: 3px;
  ${justifyContentFlexEnd}
  gap:4px;
`;

const ButtonWrapper = styled.div`
  ${({ isAddClear }) =>
    isAddClear
      ? css`
          width: 84px;
          height: 29px;
        `
      : css``}

  ${layerB}
  border-radius: 27px;

  ${flexBoxCenter}
`;

const Button = styled.button`
  ${({ isAddClear }) =>
    isAddClear
      ? css`
          width: 82px;
          height: 27px;
        `
      : css``}

  ${layerA180Deg}
  border-radius: 25px;

  ${flexBoxCenter}
`;

const ButtonIndent = styled.div`
  ${({ isAddClear }) =>
    isAddClear
      ? css`
          width: 76px;
          height: 21px;
        `
      : css``}

  ${layerB}
  border-radius: 20px;

  ${flexBoxCenter}
`;

const ButtonTop = styled.div`
  ${({ isAddClear }) =>
    isAddClear
      ? css`
          width: 74px;
          height: 19px;
        `
      : css``}

  ${layerA180Deg}
  border-radius: 25px;

  ${flexBoxCenter}
`;

const Title = styled.p`
  font-size: 10px;
`;
